'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var DEFAULT_COUNTRY = 'us';

var LANG_TO_ISO2 = {
  de: 'de',
  en: 'us',
  es: 'es',
  fi: 'fi',
  fr: 'fr',
  it: 'it',
  ja: 'jp',
  nl: 'nl',
  sv: 'se'
};

exports.default = function (locale) {
  var _locale$split = locale.split('-'),
      _locale$split2 = _slicedToArray(_locale$split, 2),
      lang = _locale$split2[0],
      country = _locale$split2[1];

  if (country) {
    return country;
  } else if (LANG_TO_ISO2[lang]) {
    return LANG_TO_ISO2[lang];
  }

  return DEFAULT_COUNTRY;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/adapters/getCountryCodeFromLocale.js
// module id = 568
// module chunks = 3 4 5